import actions from "@/store/modules/entrance-exit/actions";
import mutations from "@/store/modules/entrance-exit/mutations";
import state from "@/store/modules/entrance-exit/state";

export default {
    actions,
    mutations,
    state
}